import React from 'react';
import PropTypes from 'prop-types';

function SingleBar({
    item,
    width,
    height,
    data,
    color,
    percentage,
    onMouseEnterSingleBar,
    onMouseExitSingleBar
}) {
    return (
        <div className='single-bar'
            onMouseEnter={() => onMouseEnterSingleBar(item, true)}
            onMouseLeave={() => onMouseExitSingleBar(item, false)}>
            <svg width={width} height={height}>
                <path
                    d={data}
                    fill={color}
                />
            </svg>
            <p style={{ fontSize: 12 }}>{percentage}</p>
        </div>

    );
}

SingleBar.propTypes = {
    onMouseEnterSingleBar: PropTypes.func.isRequired,
    onMouseExitSingleBar: PropTypes.func.isRequired,
};

export default SingleBar;
